import { themes } from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import SiteWide from '../Global/SiteWide/SiteWide';
const Container = styled.section `
  color: ${cssVar('fgColor')};

  /* Apply the spacing values. */
  margin-top: var(--margin-top);
  margin-bottom: var(--margin-bottom);
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);

  /* Set the spacing value for each breakpoint. */
  @media ${until(Device.TabletLarge)} {
    ${setCssVar('sectionMargin', '48px')};
  }

  /* Set the spacing value for each breakpoint. */
  @media ${from(Device.TabletLarge)} {
    ${setCssVar('sectionMargin', '96px')};
  }

  /* Set the margin values if margin spacing is used. */
  ${({ spacing }) => spacing === 'margin' &&
    css `
      --margin-top: ${cssVar('sectionMargin')};
      --margin-bottom: ${cssVar('sectionMargin')};
    `}

  /* Set the padding values if padding spacing is used. */
  ${({ spacing }) => spacing === 'padding' &&
    css `
      --padding-top: ${cssVar('sectionMargin')};
      --padding-bottom: ${cssVar('sectionMargin')};
    `}

  /* Adjust the margin/padding values based on the flush setting. */
  ${({ flush }) => flush === 'top' &&
    css `
      --margin-top: 0;
      --padding-top: 0;
    `}

  /* Adjust the margin/padding values based on the flush setting. */
  ${({ flush }) => flush === 'bottom' &&
    css `
      --margin-bottom: 0;
      --padding-bottom: 0;
    `}

  /* Adjust the margin/padding values based on the flush setting. */
  ${({ flush }) => flush === 'both' &&
    css `
      --margin-top: 0;
      --margin-bottom: 0;
      --padding-top: 0;
      --padding-bottom: 0;
    `}

  /* Apply the specified theme configuration. */
  ${({ themeOption }) => themeOption &&
    css `
      ${themes[themeOption]}
    `}
`;
const StyledSiteWide = styled(SiteWide) ``;
export default {
    Container,
    SiteWide: StyledSiteWide,
};
